import actionTypes from '../constants/action-types';

const renameFolder = (folderId, folderName) => ({
  type: actionTypes.RENAME_FOLDER,
  payload: {
    folderId,
    folderName,
  },
});

export default renameFolder;
